import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Seo } from 'src/components/seo';
import {
  E2eLogicObjectsWithAasoParams,
  e2eLogicUtils_getRoutingLogicObjects,
} from 'src/e2e-redesign/business-logic/e2e-logic-utils';
import { e2eConfigLogic_updateAppConfigurationObject } from 'src/e2e-redesign/business-logic/e2e-path-logic';
import PageIntro from 'src/e2e-redesign/components/PageIntro';
import ThemedContainer from 'src/e2e-redesign/components/ThemedContainer';
import {
  getStartedLogic_functionsAndVals,
  getStartedLogic_init,
} from 'src/e2e-redesign/views/get-started/logic/get-started-logic';
import { NewE2ERoutes } from 'src/enums/routes.enums';

import PaymentOptionApplyCard from './payment-option-apply-card';
import PaymentOptionsCard from './payment-options-card';

// fetch disclosure logos

// fetch payment option details

function buildProviderDisclosuresPath(
  store_name: string,
  store_uuid: string,
  e2e_form_id: string,
  aaso_id: string,
): string {
  const storeName = encodeURIComponent(store_name);
  const storeUuid = encodeURIComponent(store_uuid);
  const e2eFormId = encodeURIComponent(e2e_form_id);
  const aasoId = encodeURIComponent(aaso_id);
  return `/${storeName}/${storeUuid}/${e2eFormId}/${aasoId}/${NewE2ERoutes.ProviderDisclosures}`;
}

export default function AdditionalPaymentOptions() {
  const routingPackage: E2eLogicObjectsWithAasoParams = e2eLogicUtils_getRoutingLogicObjects();
  getStartedLogic_init(routingPackage);
  console.log('routingPackage', routingPackage);
  const fnv = getStartedLogic_functionsAndVals(routingPackage);
  const { disclosureLogos, drawerState, e2ePath, multi_paths_exist } = fnv.v;
  const { toggleDrawer, handleGoBack } = fnv.fn;

  const handleApplyRouting = () => {
    e2eConfigLogic_updateAppConfigurationObject(routingPackage);
    const { store_name, store_uuid, e2e_form_id, aaso_id } = routingPackage.params;
    const path = buildProviderDisclosuresPath(store_name, store_uuid, e2e_form_id, aaso_id);
    routingPackage.navigate(path);
  };

  return (
    <>
      <Seo title="Purchase Options" />
      <ThemedContainer>
        <PageIntro title="Purchase Options" paragraph="Review below" />
        <Box display="flex" flexDirection="column" gap={3}>
          <PaymentOptionsCard />
          <PaymentOptionApplyCard
            logos={disclosureLogos}
            drawerState={drawerState}
            toggleDrawer={toggleDrawer}
            e2ePath={e2ePath}
            onApply={handleApplyRouting}
            multiPathsExist={multi_paths_exist}
            onGoBack={handleGoBack}
          />
        </Box>
      </ThemedContainer>
    </>
  );
}
